var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg132Trash1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.016,262.195l-6,148.933c-0.444,11.037,8.142,20.344,19.179,20.789c0.275,0.011,0.547,0.017,0.819,0.017 c10.674,0,19.536-8.434,19.97-19.195l6-148.933c0.444-11.037-8.142-20.344-19.179-20.789 C331.769,242.584,322.461,251.158,322.016,262.195z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,163H86c-5.563,0-10.875,2.317-14.66,6.396c-3.785,4.078-5.7,9.548-5.285,15.096L85.082,438.94 c0.008,0.108,0.017,0.217,0.027,0.325c1.817,19.924,10.955,38.326,25.73,51.816C125.615,504.571,144.771,512,164.778,512h182.444 c41.667,0,75.917-31.032,79.67-72.184c1.003-11-7.101-20.73-18.101-21.734c-11.005-1.002-20.731,7.102-21.734,18.101 C385.195,456.602,368.07,472,347.222,472H164.778c-20.771,0-37.865-15.563-39.821-36.224L107.551,203h296.926l-10.396,141.535 c-0.809,11.016,7.465,20.602,18.481,21.411c11.017,0.813,20.602-7.465,21.411-18.481l11.972-163 c0.407-5.544-1.511-11.007-5.295-15.079C436.866,165.314,431.559,163,426,163z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472,83H351V60c0-33.084-26.916-60-60-60h-70c-33.084,0-60,26.916-60,60v23H40c-11.046,0-20,8.954-20,20s8.954,20,20,20 h432c11.046,0,20-8.954,20-20S483.046,83,472,83z M311,83H201V60c0-11.028,8.972-20,20-20h70c11.028,0,20,8.972,20,20V83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,263v148.933c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20V263c0-11.046-8.954-20-20-20S236,251.954,236,263z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.195,243.016c-11.037,0.445-19.623,9.752-19.179,20.789l6,148.933c0.434,10.763,9.295,19.195,19.97,19.195 c0.272,0,0.545-0.006,0.819-0.017c11.037-0.445,19.623-9.752,19.179-20.789l-6-148.933 C189.54,251.158,180.229,242.584,169.195,243.016z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg132Trash1);
export default __webpack_public_path__ + "static/media/132-trash-1.f0c1e96a26c7e9f6203e5dd03651be25.svg";
export { ForwardRef as ReactComponent };